<template>
    <ul class="list-group">
        <li
            v-if="
                selectedMonthBonus.comments &&
                selectedMonthBonus.comments.length > 0
            "
            class="list-group-item flex-column align-items-start tarief"
        >
            <div
                v-for="(comment, index) in selectedMonthBonus.comments"
                :key="comment.id"
            >
                <RockOverviewMessage
                    :comment="comment"
                    :show-delete-button="
                        ((isManager && commentIsFromManager(index)) ||
                            (!isManager && commentIsFromUser(index))) &&
                        ((isManager && !commentIsReply(index)) ||
                            (!isManager && commentIsReply(index))) &&
                        ((isManager && !commentHasReply()) ||
                            (!isManager && commentHasReply()))
                    "
                    :show-edit-button="
                        (isManager && commentIsFromManager(index)) ||
                        (!isManager && commentIsFromUser(index))
                    "
                />
                <RockOverviewMessage
                    v-if="!isManager && !commentHasReply()"
                    :reply="comment.id"
                />
            </div>
        </li>

        <li
            v-else-if="isManager"
            class="list-group-item flex-column align-items-start tarief"
        >
            <RockOverviewMessage />
        </li>
    </ul>
</template>
<script>
import RockOverviewMessage from '@/components/RockOverviewMessage';

export default {
    name: 'RockOverviewMessages',
    components: {
        RockOverviewMessage
    },
    props: {
        selectedMonthBonus: {
            type: Object
        },
        isManager: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            userInfo: {}
        };
    },
    mounted() {
        this.$keycloak.getUserInfo().then((response) => {
            this.userInfo = response;
        });
    },
    methods: {
        commentHasReply: function () {
            if (this.selectedMonthBonus.comments.length > 1) {
                return true;
            }
            return false;
        },
        commentIsReply: function (index) {
            if (this.selectedMonthBonus.comments.length > 1) {
                if (index === 1) {
                    return true;
                }
            }
            return false;
        },
        commentIsFromUser: function (index) {
            // assuming first comment is from user (no other check possible now)
            if (index !== 0) {
                return true;
            }
            return false;
        },
        commentIsFromManager: function (index) {
            // assuming first comment is from admin (no other check possible now)
            if (index === 0) {
                return true;
            }
            return false;
        }
    }
};
</script>
